

<script>

// ** Инициализация глобальных объектов, каким-то образом связанных с html-элементами происходит здесь - в главном компоненте App.svelte
  
  import { onDestroy, onMount, tick } from "svelte";
  import Stamp from "./components/tomat/Stamp.svelte";
  import { a, getSelectedShapes } from "../shared/globalState/a";
  import { a as b } from "../libs/canvas-text/src/shared/state";

  import { g, getElemComputedHeight, setHeights } from "../shared/common";
  import * as jscolor from "../libs/jscolor/jscolor";
  import SelectWindow from "./components/tomat/SelectWindow.svelte";
  import ObjectProperties from "./components/tomat/ObjectProperties.svelte";
  import KeySet from "./components/tomat/KeySet.svelte";
  import CanvasShapes from "./components/tomat/CanvasShapes.svelte";
  import Toolbar from "./components/tomat/Toolbar.svelte";
  import { fromEvent, take } from "rxjs";
  import { stored } from "./stores/stores";

  import { fontSize$ } from "../libs/canvas-text/src/shared/state";
  import CanvasText from "./components/tomat/CanvasText.svelte";
  import BlockSearch from "./components/tomat/BlockSearch.svelte";
  import AlertDialog from "./components/dialogs/AlertDialog.svelte";
  import InputBlockDataDialog from "./components/dialogs/InputBlockDataDialog.svelte";
  import ErrorDialog from "./components/dialogs/ErrorDialog.svelte";

  import Graph from "graphology";
  import Sigma from "sigma";
  
  import { updateGraphNodesCoordinatesZoom } from "../services/graph&network";
  import { allSimplePaths } from "graphology-simple-path";
  import { bfs } from "graphology-traversal";
  import { topologicalGenerations, forEachNodeInTopologicalOrder, forEachTopologicalGeneration, topologicalSort } from "graphology-dag";
  import { bidirectional, singleSource } from "graphology-shortest-path";
  import { forEachConnectedComponent, forEachConnectedComponentOrder } from "graphology-components";
  import AppMode from "./components/tomat/DrawingMode.svelte";
  import DrawingMode from "./components/tomat/DrawingMode.svelte";
  import { DrawingModes } from "../shared/enums";
  import { selectAllShapes } from "@app/shared/state";

  fontSize$.subscribe((fontSize) => {
    curFontSize = fontSize;
  });

  let isStampDialogVisible = true;
  let isBlockSearchVisible = false;

  let alertDialogIsVisible = false;
  let alertTitle;
  let alertMessage;
  let alertDialogTimeout = 2000;

  let inputBlockDataDialogIsVisible = false;
  let inputBlockDataDialogTitle;
  let inputBlockDataDialogMessage;
  let inputDialogValue;

  let errorDialogIsVisible = false;
  let errorTitle;
  let errorMessage;

  let curFontSize = null;
  let isStampPdfVisible = true;
  let currentMode = "";
  let currentRealScale = 1;

  let isNetworkSketchModeHidden = false;
  let sigmaContainer = null;

  // ********* stamp is visible *********
  $: a.isStampPdfVisible = isStampPdfVisible.detail;

  a.stamp$.subscribe((v) => {
    isStampDialogVisible = v;
  });

  let showKeyboard = false;

  $: curFontSize = b.initFontSize;

  // ********* block search is visible *********
  a.showBlockSearch$.subscribe((v) => {
    isBlockSearchVisible = !isBlockSearchVisible;
    if (!v) {
      isBlockSearchVisible = false;
    }
  });

  // ********* dialogs *********
  a.showAlertDialog$.subscribe((v) => {
    alertTitle = v.title;
    alertMessage = v.message;
    alertDialogIsVisible = v.isVisible;
    alertDialogTimeout = v.timeout ? v.timeout : 2000;
  });

  a.showInputBlockCollectionDialog$.subscribe((v) => {
    inputBlockDataDialogTitle = v.title;
    inputBlockDataDialogMessage = v.message;
    inputDialogValue = v.value;
    inputBlockDataDialogIsVisible = v.isVisible;
  });

  a.showErrorDialog$.subscribe((v) => {
    errorTitle = v.title;
    errorMessage = v.message;
    errorDialogIsVisible = v.isVisible;
  });

  // ******** mode ********

  a.mode$.subscribe((v) => {
    currentMode = v;
  });

  // ********* toolbar height *********

  var resizeObserver = new ResizeObserver((entries) => {
    setHeights();
  });
  resizeObserver.observe(document.body);

  // ******************** jscolor ****************
  jscolor.presets.default = {
    width: 141, // make the picker a little narrower
    position: "right", // position it to the right of the target
    previewPosition: "left", // display color preview on the right
    previewSize: 40, // make the color preview bigger
    palette: $stored.colorPalette,
  };
  
  // Initialize jscolor
  jscolor.init();


  onMount(async () => {
    // Wait for the container to be available
    await tick();
    
    a.drawingMode$.pipe().subscribe((v) => {
      var mode = v;
      if(mode === DrawingModes.networkSketch){
        isNetworkSketchModeHidden = false;
        
      } else {
        isNetworkSketchModeHidden = true;
      }
    });

    a.sigmaUpdate$.subscribe(v=>{
      const selectedElements = getSelectedShapes();
      if(selectedElements){
        const graph = selectedElements[0]?.getGraph();
        a.sigmaInstance = new Sigma(graph, sigmaContainer, {allowInvalidContainer:true});
      }
    })
    
  });
</script>

<Stamp bind:hidden={isStampDialogVisible}></Stamp>
<BlockSearch bind:isVisible={isBlockSearchVisible}></BlockSearch>
<AlertDialog bind:isVisible={alertDialogIsVisible} bind:title={alertTitle} bind:message={alertMessage} bind:timeout={alertDialogTimeout}></AlertDialog>
<InputBlockDataDialog bind:isVisible={inputBlockDataDialogIsVisible} bind:title={inputBlockDataDialogTitle} bind:message={inputBlockDataDialogMessage}></InputBlockDataDialog>
<ErrorDialog bind:isVisible={errorDialogIsVisible} bind:title={errorTitle} bind:message={errorMessage}></ErrorDialog>

<div class="grid">
  <div class="area-toolbar">
    <div class="flex-row jcc">
      <div>
        <Toolbar on:isStampVisible={(v) => (isStampPdfVisible = v)} on:real-scale-changed={(v) => (currentRealScale = v.detail)} bind:curFontSize bind:showKeyboard preventDefaultEsc></Toolbar>
      </div>
    </div>
  </div>
  <div class="area-select">
    <!-- <SelectWindow cl="m-mb-05"></SelectWindow> -->
    <ObjectProperties></ObjectProperties>
  </div>
  <div class="area-properties"></div>
  <div class="area-canvas">
    <div class="sigma-container" class:hidden={isNetworkSketchModeHidden} bind:this={sigmaContainer}></div>
    <CanvasShapes></CanvasShapes>
    <CanvasText></CanvasText>
  </div>
</div>

<div class="side-drawingMode-block">
  <div class="mb-2">
    <DrawingMode></DrawingMode>
  </div>
</div>

<div id="info" class="side-info-block">
  <div style="display: flex; flex-direction:column; user-select: none;">
    <div id="mode" class="text-slate-600">
      режим <code>{currentMode}</code>
    </div>
    <div id="real-scale" class="text-slate-600">
      масштаб <code>1:{currentRealScale.toFixed(2)}</code>
    </div>
    <p id="message1"></p>
    <p id="message2"></p>
    <p id="message3"></p>
    <p id="error"></p>
  </div>
</div>

<style>
  .grid {
    display: grid;
    grid-template-areas:
      "a a"
      "b c"
      "b d";
    grid-template-columns: 1fr 350px; /* Increased right panel width for better property display */
  }
  .area-toolbar {
    grid-area: a;
    background-color: rgb(241 245 249 / 1);
  }
  .area-canvas {
    grid-area: b;
  }
  .area-select {
    grid-area: c;
  }
  .area-properties {
    grid-area: d;
  }
  .side-drawingMode-block {
    position: absolute;
    top: var(--toolbar-height);
    z-index: 10;
    padding: 0 1rem;
    margin-top: .5rem;
  }
  .side-info-block {
    position: absolute;
    top: calc(var(--appMode-block-height) + var(--toolbar-height));
    z-index: 10;
    padding: 0 1rem;
    margin-top: .5rem;
  }

  .sigma-container {
    position: absolute;
    width: 500px;
    height: 400px;
    bottom: 50px;
    right: 300px;
    background-color: aliceblue;
    z-index: 50;
  }

  .hidden{
    display: none;
  }
</style>
